import { Toaster as Sonner } from "sonner";
import { useThemeStore } from "@/stores/theme.store";

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  const theme = useThemeStore((s) => s.theme);
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      richColors
      closeButton
      {...props}
    />
  );
}
